import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

import TelemetryProvider from 'application-insights/TelemetryProvider-component'

import { ThemeProvider } from '@mui/material'
import { StyledEngineProvider } from '@mui/material/styles'
import { LicenseInfo } from '@mui/x-date-pickers-pro'

import GoogleAnalytics from 'components/common/GoogleAnalytics'
import ScrollToTop from 'components/common/ScrollToTop'
import ErrorToast from 'components/core/ErrorBoundary/ErrorServerToast/ErrorServerToast-component'
import AccountStatusChangedModal from 'components/core/Forms/AccountStatusChangedForm/AccountStatusChangedForm-modal'
import LanguageRender from 'components/core/Language/Render/LanguageRender-component'
import SessionTimeout from 'components/core/SessionTimeout/SessionTimeout'
import ModalForms from 'components/modals'
import useWindowDimensions from 'hooks/useWindowDimensions'
import { themeConfig, useTheme } from 'themes'
import { APPLICATION_INSIGHTS_INSTRUMENTATION_KEY, MUI_LICENCE_KEY, THEME_NAME } from 'utils/helperConfig'

import AppRoutes from './Routes'

import 'utils/imagesPreload'

import './i18n'

const BRAND_NAME = themeConfig.BRAND_NAME
const ANALYTICS_TOGGLE_ENABLED = themeConfig.ANALYTICS_TOGGLE_ENABLED

function HeadComponent() {
    const { t } = useTranslation()

    return (
        <Helmet>
            <meta name="description" content={t('Landing.Title')} />
            <meta name="keywords" content={`${THEME_NAME}, ${BRAND_NAME}`} />
            <title>
                {BRAND_NAME} - {t('Landing.Title')}
            </title>
        </Helmet>
    )
}

function App() {
    LicenseInfo.setLicenseKey(MUI_LICENCE_KEY)
    const { formTheme } = useTheme()

    const { height } = useWindowDimensions()

    document.documentElement.style.setProperty('--doc-height', `${height}px`)

    return (
        <TelemetryProvider instrumentationKey={APPLICATION_INSIGHTS_INSTRUMENTATION_KEY}>
            {ANALYTICS_TOGGLE_ENABLED && <GoogleAnalytics />}
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={formTheme}>
                    <ModalForms>
                        <div className="App">
                            <SessionTimeout />
                            <LanguageRender />
                            <ScrollToTop />
                            <AccountStatusChangedModal />
                            <AppRoutes />
                            <HeadComponent />
                            <ErrorToast />
                        </div>
                    </ModalForms>
                </ThemeProvider>
            </StyledEngineProvider>
        </TelemetryProvider>
    )
}

export default App
